import { QUESTIONS_ROUTES } from '../../constants/_routes'
import { formatRoute } from 'react-router-named-routes'
import questionsTypes from '../../constants/questionsTypes'
import { axios } from '../../services'

// import { try_force_logoff } from '../auth'
//
const get_question_request = () => {
  return {
    type: questionsTypes.get.request
  }
}

const get_question_success = (response) => {
  return {
    type: questionsTypes.get.success,
    payload: response.data.question
  }
}

const get_question_failure = (messages) => {
  return {
    type: questionsTypes.get.failure,
    payload: messages
  }
}

const get_question = (question_id) => {
  return function (dispatch) {
    // Before Request
    dispatch(get_question_request())

    // Request
    axios.get(
      formatRoute(QUESTIONS_ROUTES.get, {id: question_id})
    ).then( response => {
      // success
      dispatch( get_question_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error fetching question."]
      }
      // dispatch( try_force_logoff(error.response.data) )
      dispatch( get_question_failure(errors))
    })
  }
}

const get_question_by_position = (skip=0, filters={}, sort='', order='') => {
  return function (dispatch) {
    // Before Request
    dispatch(get_question_request())

    // Request
    axios.get(
      QUESTIONS_ROUTES.get_question_by_position,
      {
        params: {
          sort: sort,
          order: order,
          filters: filters,
          skip: skip
        }
      }
    ).then( response => {
      // success
      dispatch( get_question_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error fetching question."]
      }
      // dispatch( try_force_logoff(error.response.data) )
      dispatch( get_question_failure(errors))
    })
  }
}

export {
  get_question,
  get_question_by_position
}



// WEBPACK FOOTER //
// ./src/js/actions/questions/get.js